import {z} from 'zod';

export const ArticleCreateFormSchema = z.object({
  catalogNumber: z.string(),
  manufacturerId: z.string(),
  warehouseId: z.string(),
  name: z.string(),
  handlingUnit: z.string(),
  storageLocationId: z.string().nullish(),
  dispensingUnit: z.number().nullish(),
  activeFolderId: z.string(),
});

export type ArticleCreateForm = z.infer<typeof ArticleCreateFormSchema>;
